module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar shadow-3 d-print-none",
    class: {
      'active': _vm.showMenu
    }
  }, [_c('div', {
    staticClass: "sidebar-wrapper"
  }, [_c('div', {
    staticClass: "logo d-flex pl-3 align-items-center"
  }, [_c('router-link', {
    staticClass: "brand",
    attrs: {
      "to": '/'
    }
  }, [_vm._v("Eros")])], 1), _vm._v(" "), _c('ul', {
    staticClass: "nav"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/products"
    }
  }, [_c('svg', {
    attrs: {
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 24 24",
      "xml:space": "preserve",
      "width": "24",
      "height": "24"
    }
  }, [_c('g', {
    staticClass: "nc-icon-wrapper",
    attrs: {
      "transform": "translate(0.5, 0.5)",
      "fill": "#ffffff"
    }
  }, [_c('rect', {
    attrs: {
      "x": "3",
      "y": "9",
      "fill": "none",
      "stroke": "#ffffff",
      "stroke-width": "1",
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      "width": "18",
      "height": "14",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "data-color": "color-2",
      "fill": "none",
      "stroke": "#ffffff",
      "stroke-width": "1",
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      "x1": "5",
      "y1": "5",
      "x2": "19",
      "y2": "5",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "data-color": "color-2",
      "fill": "none",
      "stroke": "#ffffff",
      "stroke-width": "1",
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      "x1": "8",
      "y1": "1",
      "x2": "16",
      "y2": "1",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "data-color": "color-2",
      "fill": "none",
      "stroke": "#ffffff",
      "stroke-width": "1",
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      "points": " 16,14 16,16 8,16 8,14 ",
      "stroke-linejoin": "round"
    }
  })])]), _vm._v(" "), _c('span', [_vm._v("\n            Artigos\n          ")])])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/stocks"
    }
  }, [_c('svg', {
    attrs: {
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 24 24",
      "xml:space": "preserve",
      "width": "24",
      "height": "24"
    }
  }, [_c('g', {
    staticClass: "nc-icon-wrapper",
    attrs: {
      "transform": "translate(0.5, 0.5)",
      "fill": "#ffffff"
    }
  }, [_c('polyline', {
    attrs: {
      "data-color": "color-2",
      "fill": "none",
      "stroke": "#ffffff",
      "stroke-width": "1",
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      "points": " 8,5 8,1 16,1 16,5 ",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "fill": "none",
      "stroke": "#ffffff",
      "stroke-width": "1",
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      "points": "9,15 1,15 1,5 23,5 23,15 15,15 ",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "fill": "none",
      "stroke": "#ffffff",
      "stroke-width": "1",
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      "points": "22,18 22,23 2,23 2,18 ",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "data-color": "color-2",
      "x": "9",
      "y": "13",
      "fill": "none",
      "stroke": "#ffffff",
      "stroke-width": "1",
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      "width": "6",
      "height": "4",
      "stroke-linejoin": "round"
    }
  })])]), _vm._v(" "), _c('span', [_vm._v("\n            Stocks\n          ")])])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/orders"
    }
  }, [_c('svg', {
    attrs: {
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 24 24",
      "xml:space": "preserve",
      "width": "24",
      "height": "24"
    }
  }, [_c('g', {
    staticClass: "nc-icon-wrapper",
    attrs: {
      "transform": "translate(0.5, 0.5)",
      "fill": "#ffffff"
    }
  }, [_c('polyline', {
    attrs: {
      "fill": "none",
      "stroke": "#ffffff",
      "stroke-width": "1",
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      "points": "20,4 22,4 22,23 2,23 2,4 4,4 ",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "none",
      "stroke": "#ffffff",
      "stroke-width": "1",
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      "d": "M14,3c0-1.105-0.895-2-2-2 s-2,0.895-2,2H7v4h10V3H14z",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "data-color": "color-2",
      "fill": "none",
      "stroke": "#ffffff",
      "stroke-width": "1",
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      "x1": "7",
      "y1": "11",
      "x2": "17",
      "y2": "11",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "data-color": "color-2",
      "fill": "none",
      "stroke": "#ffffff",
      "stroke-width": "1",
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      "x1": "7",
      "y1": "15",
      "x2": "17",
      "y2": "15",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "data-color": "color-2",
      "fill": "none",
      "stroke": "#ffffff",
      "stroke-width": "1",
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      "x1": "7",
      "y1": "19",
      "x2": "11",
      "y2": "19",
      "stroke-linejoin": "round"
    }
  })])]), _vm._v(" "), _c('span', [_vm._v("\n            Pedidos\n          ")])])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/supply-orders"
    }
  }, [_c('svg', {
    attrs: {
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 24 24",
      "xml:space": "preserve",
      "width": "24",
      "height": "24"
    }
  }, [_c('g', {
    staticClass: "nc-icon-wrapper",
    attrs: {
      "transform": "translate(0.5, 0.5)",
      "fill": "#ffffff"
    }
  }, [_c('circle', {
    attrs: {
      "data-color": "color-2",
      "fill": "none",
      "stroke": "#ffffff",
      "stroke-width": "1",
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      "cx": "7",
      "cy": "21",
      "r": "2",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "data-color": "color-2",
      "fill": "none",
      "stroke": "#ffffff",
      "stroke-width": "1",
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      "cx": "19",
      "cy": "21",
      "r": "2",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "data-cap": "butt",
      "fill": "none",
      "stroke": "#ffffff",
      "stroke-width": "1",
      "stroke-miterlimit": "10",
      "points": "4.667,6 22,6 20,16 6,16 4,1 1,1 ",
      "stroke-linejoin": "round",
      "stroke-linecap": "round"
    }
  })])]), _vm._v(" "), _c('span', [_vm._v("\n            Compras\n          ")])])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/barcode"
    }
  }, [_c('svg', {
    attrs: {
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 24 24",
      "xml:space": "preserve",
      "width": "24",
      "height": "24"
    }
  }, [_c('g', {
    staticClass: "nc-icon-wrapper",
    attrs: {
      "transform": "translate(0.5, 0.5)",
      "fill": "#ffffff"
    }
  }, [_c('polygon', {
    attrs: {
      "fill": "none",
      "stroke": "#ffffff",
      "stroke-width": "1",
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      "points": "10,10 1,10 1,1 10,1 10,1 ",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "fill": "none",
      "stroke": "#ffffff",
      "stroke-width": "1",
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      "points": "23,10 14,10 14,1 14,1 23,1 ",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "fill": "none",
      "stroke": "#ffffff",
      "stroke-width": "1",
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      "points": "10,23 1,23 1,14 10,14 10,14 ",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "fill": "none",
      "stroke": "#ffffff",
      "stroke-width": "1",
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      "points": "23,19 23,14 19,14 19,17 15,17 15,14 ",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "fill": "none",
      "stroke": "#ffffff",
      "stroke-width": "1",
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      "points": "23,23 15,23 15,21 ",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "data-color": "color-2",
      "fill": "none",
      "stroke": "#ffffff",
      "stroke-width": "1",
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      "points": " 6,6 5,6 5,5 6,5 6,6 ",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "data-color": "color-2",
      "fill": "none",
      "stroke": "#ffffff",
      "stroke-width": "1",
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      "points": " 19,6 18,6 18,6 18,5 19,5 ",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "data-color": "color-2",
      "fill": "none",
      "stroke": "#ffffff",
      "stroke-width": "1",
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      "points": " 6,19 5,19 5,18 6,18 6,19 ",
      "stroke-linejoin": "round"
    }
  })])]), _vm._v(" "), _c('span', [_vm._v("Código Barras")])])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item dropdown"
  }, [_c('a', {
    staticClass: "nav-link dropdown-toggle",
    attrs: {
      "href": "#",
      "id": "navbarDropdown",
      "role": "button",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_c('svg', {
    attrs: {
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 24 24",
      "xml:space": "preserve",
      "width": "24",
      "height": "24"
    }
  }, [_c('g', {
    staticClass: "nc-icon-wrapper",
    attrs: {
      "fill": "#ffffff",
      "transform": "translate(0.5, 0.5)"
    }
  }, [_c('polyline', {
    attrs: {
      "data-color": "color-2",
      "fill": "none",
      "stroke": "#ffffff",
      "stroke-width": "1",
      "stroke-linecap": "square",
      "stroke-miterlimit": "10",
      "points": " 2,16 2,22 22,22 22,16 ",
      "stroke-linejoin": "miter"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "data-cap": "butt",
      "fill": "none",
      "stroke": "#ffffff",
      "stroke-width": "1",
      "stroke-miterlimit": "10",
      "x1": "12",
      "y1": "17",
      "x2": "12",
      "y2": "2",
      "stroke-linejoin": "miter",
      "stroke-linecap": "butt"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "fill": "none",
      "stroke": "#ffffff",
      "stroke-width": "1",
      "stroke-linecap": "square",
      "stroke-miterlimit": "10",
      "points": "18,8 12,2 6,8 ",
      "stroke-linejoin": "miter"
    }
  })])]), _vm._v(" "), _c('span', [_vm._v("\n            Guias CTT\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu",
    attrs: {
      "aria-labelledby": "navbarDropdown"
    }
  }, [_c('router-link', {
    staticClass: "dropdown-item",
    attrs: {
      "to": "/transport-label-list/"
    }
  }, [_vm._v("Lista de Guias")]), _vm._v(" "), _c('router-link', {
    staticClass: "dropdown-item",
    attrs: {
      "to": "/transport-label/new"
    }
  }, [_vm._v(" Nova Guia CTT ")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "user"
  }, [_c('div', {
    staticClass: "nav-item dropdown"
  }, [_c('a', {
    staticClass: "nav-link dropdown-toggle",
    attrs: {
      "href": "#",
      "id": "navbarDropdownMenuLink",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [(_vm.user.name == null) ? _c('svg', {
    attrs: {
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 24 24",
      "xml:space": "preserve",
      "width": "24",
      "height": "24"
    }
  }, [_c('g', {
    staticClass: "nc-icon-wrapper",
    attrs: {
      "fill": "#ffffff",
      "transform": "translate(0.5, 0.5)"
    }
  }, [_c('path', {
    attrs: {
      "fill": "none",
      "stroke": "#ffffff",
      "stroke-width": "1",
      "stroke-linecap": "square",
      "stroke-miterlimit": "10",
      "d": "M12,1L12,1 C9.2,1,7,3.2,7,6v3h10V6C17,3.2,14.8,1,12,1z",
      "stroke-linejoin": "miter"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "4",
      "y": "9",
      "fill": "none",
      "stroke": "#ffffff",
      "stroke-width": "1",
      "stroke-linecap": "square",
      "stroke-miterlimit": "10",
      "width": "16",
      "height": "14",
      "stroke-linejoin": "miter"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "data-color": "color-2",
      "fill": "none",
      "stroke": "#ffffff",
      "stroke-width": "1",
      "stroke-linecap": "square",
      "stroke-miterlimit": "10",
      "cx": "12",
      "cy": "15",
      "r": "2",
      "stroke-linejoin": "miter"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "data-color": "color-2",
      "fill": "none",
      "stroke": "#ffffff",
      "stroke-width": "1",
      "stroke-linecap": "square",
      "stroke-miterlimit": "10",
      "x1": "12",
      "y1": "17",
      "x2": "12",
      "y2": "19",
      "stroke-linejoin": "miter"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.user.name !== null) ? _c('img', {
    staticClass: "rounded-circle",
    attrs: {
      "width": "25px",
      "height": "25px",
      "src": _vm.user.gravatar
    }
  }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.user.name))])]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu",
    attrs: {
      "aria-labelledby": "navbarDropdownMenuLink"
    }
  }, [_c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.user.email == null),
      expression: "user.email == null"
    }],
    staticClass: "dropdown-item",
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("Login")]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.user.email !== null),
      expression: "user.email !== null"
    }],
    staticClass: "dropdown-item",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.onLogout($event)
      }
    }
  }, [_vm._v("Logout")]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "https://api.ohjoy.pt/graphql",
      "target": "_blank"
    }
  }, [_vm._v("Graphiql")])], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12417862","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/navbar/Sidebar.vue
// module id = 596
// module chunks = 66